<section class="address-book-overview">
  <app-con-x-table-page
    eyebrow="Construct-X"
    eyebrowIcon="contacts"
    [title]="organisationId ? 'Adressbücher der Organisation' : 'Meine Adressbücher'"
    description="Kontakte für Personen und Organisationen zentral finden und verwalten."
    ariaLabel="Adressbücher"
    locale="de-DE"
    [data]="addressBooks"
    [columns]="columns"
    [actions]="pageActions"
    [rowActions]="rowActions"
    [inspector]="inspector"
    [selectedRow]="selectedAddressBook"
    [rowId]="'addressBookId'"
    [summaryItems]="summaryItems"
    [emptyState]="emptyState"
    [loading]="loading"
    loadingMessage="Adressbücher werden geladen …"
    [errorMessage]="errorMessage"
    errorTitle="Adressbücher konnten nicht geladen werden"
    retryLabel="Erneut laden"
    searchPlaceholder="Adressbuch suchen"
    noResultsTitle="Kein passendes Adressbuch"
    noResultsDescription="Ändern Sie den Suchbegriff."
    [refreshable]="true"
    refreshTooltip="Adressbücher aktualisieren"
    (selectedRowChange)="selectedAddressBook = $event"
    (pageAction)="handlePageAction($event)"
    (rowAction)="handleRowAction($event)"
    (refreshRequested)="loadAddressBooks()"
    (retryRequested)="loadAddressBooks()">
  </app-con-x-table-page>
</section>
